'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Headline = function Headline(_ref) {
    var text = _ref.text,
        theme = _ref.theme,
        stylizr = _ref.stylizr;
    return _react2.default.createElement(
        'h1',
        { className: theme.headline, 'data-test-tag': '@spp/ui-headline' },
        stylizr(text.value, text.markup)
    );
};

Headline.propTypes = {
    text: _irisPropTypes.objects.text.isRequired,
    stylizr: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
        headline: _propTypes2.default.string
    })
};

Headline.defaultProps = {
    stylizr: function stylizr(text) {
        return text;
    },
    theme: {}
};

exports.default = Headline;
//# sourceMappingURL=Headline.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-headline/lib/cjs/Headline.js
 ** module id = 519
 ** module chunks = 1
 **/